import React, { useEffect, useState, useContext } from "react";
import classes from "./LocationDashboard.module.css";
import Action from "./Actions";
import Map from "./View/Map";
import Dashboard from "./View/Dashboard";
import axios from "../../Axios";
import { Urls } from "../../Urls";
import { getUserData, isFirstTimeUser } from "./Utility";
import "./style.css";
import { Container, Row, Column } from "../Shared/FlexDiv/FlexDiv";
import { Uppercase } from "../../Utility";
import Loader from "../Loader";
import View from "./View";
import {
  isMobile,
  Activity,
  ActivityString,
  currentRequestTimeStamp,
} from "../../Constants";
// import Tour from "reactour";
import { Card, Accordion } from "react-bootstrap";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";
import mixpanel from "mixpanel-browser";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";

const LocationDashboard = (props) => {
  const location = useLocation();
  const [plantLocations, setPlantLocations] = useState([]);
  const [historyLocations, setHistoryLocations] = useState([]);
  const [searchOptions, setSearchOptions] = useState([]);
  const [analysisdata, setanalysisdata] = useState({});
  const [allowedLocations, setAllowedLocations] = useState(0);
  const [show, setShow] = useState(false);
  const [currentSearchedLocation, setCurrentSearchedLocation] = useState("");
  const [referralCredits, setReferralCredits] = useState({});
  const [isAllowed, setIsAllowed] = useState(true);
  // const [unauthorizedContent, setUnauthorizedContent] = useState(<h1>Loading</h1>)
  const [isTourOpen, setisTourOpen] = useState(true);
  // const [iscloseTour, setisCloseTour] = useState(true)
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [currentLayer, setcurrentLayer] = useState("all");
  const { userDetails, companyProfile } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [detectedCoords, setDetectedCoords] = useState(null);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  useEffect(() => {
    ReactGA.send("LoRRI - Location Dashboard");
    document.title = "LoRRI - Location Dashboard";
    // ReactGA.pageview('LocationDashboard');
    Activity([
      {
        screen: "Location Dashboard",
        module: "Location Dashboard",
        user_activity: ActivityString.LocationDashboard,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    mixpanel.track(`User has viewed location dashboard page`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Locationdashboard",
      ModuleName: "landing_page",
      ActivityLog: "userViewedLocationDashboard",
      Data: `None`,
      Definition: `User has viewed location dashboard page`,
      ActivityType: "page_view",
      UserName: `${userDetails.user_name}`,
      UserEmail: `${userDetails.email}`,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : "",
    });

    setShow(true);
    fetchLatestData(true);
  }, []);

  const [ipDetected, setIpDetected] = useState(false);

  useEffect(() => {
    if (!isUserDataLoaded) return;
    if (Object.keys(companyProfile).length === 0) return;
    if (
      companyProfile?.domain_data?.company_id &&
      Object.keys(companySettingData).length === 0
    ) {
      return;
    }

    const hasDefaultRegion =
      companySettingData?.default_map_region ||
      companyProfile?.domain_data?.default_map_region;

    const hasNoSearch =
      !analysisdata.searched_coordinates ||
      analysisdata.searched_coordinates.length === 0;

    if (hasNoSearch && historyLocations.length === 0) {
      const regionConfig = {
        india: {
          lat: 22.5937,
          lng: 78.9629,
          zoom: 4.4,
          defaultSearch: {
            district: "Delhi",
            label: "Delhi, Delhi, Delhi",
            lat: 28.7041,
            location: "Delhi",
            lon: 77.1025,
            score: 0,
            state: "Delhi",
            status: "requested",
            suggestion: "Delhi, Delhi, Delhi",
            unique_id: "Delhi_Delhi",
          },
        },
        europe: {
          lat: 54.526,
          lng: 15.2551,
          zoom: 4,
          defaultSearch: {
            district: "Île-de-France",
            label: "Paris, Île-de-France, France",
            lat: 48.8534,
            location: "Paris",
            lon: 2.3486,
            score: 0,
            state: "France",
            status: "requested",
            suggestion: "Paris, Île-de-France, France",
            unique_id: "Paris_France",
          },
        },
        us: {
          lat: 37.0902,
          lng: -95.7129,
          zoom: 4,
          defaultSearch: {
            district: "Chicago",
            label: "Chicago, Chicago, Illinois",
            lat: 41.8781,
            location: "Chicago",
            lon: -87.6298,
            score: 0,
            state: "Illinois",
            status: "requested",
            suggestion: "Chicago, Chicago, Illinois",
            unique_id: "Chicago_Illinois",
          },
        },
      };

      if (hasDefaultRegion && regionConfig[hasDefaultRegion]) {
        const region = regionConfig[hasDefaultRegion];
        setDetectedCoords({
          lat: region.lat,
          lng: region.lng,
          zoom: region.zoom,
          timestamp: Date.now(),
        });

        if (!ipDetected) {
          setIpDetected(true);
        }
      } else if (!ipDetected) {
        setIpDetected(true);
        fetch("https://free.freeipapi.com/api/json")
          .then((res) => res.json())
          .then((geo) => {
            let defaultRegionKey = "india";
            if (geo && geo.latitude && geo.longitude) {
              const lat = Number(geo.latitude);
              const lng = Number(geo.longitude);

              // United States bounds
              if (lat >= 18 && lat <= 72 && lng >= -180 && lng <= -60) {
                defaultRegionKey = "us";
              }
              // Europe bounds
              else if (lat >= 35 && lat <= 71 && lng >= -25 && lng <= 45) {
                defaultRegionKey = "europe";
              }
            }

            const region = regionConfig[defaultRegionKey];
            setDetectedCoords({
              lat: region.lat,
              lng: region.lng,
              zoom: region.zoom,
              timestamp: Date.now(),
            });
          })
          .catch(() => {
            const region = regionConfig["india"];
            setDetectedCoords({
              lat: region.lat,
              lng: region.lng,
              zoom: region.zoom,
              timestamp: Date.now(),
            });
          });
      }
    }
  }, [
    companyProfile,
    companySettingData,
    analysisdata.searched_coordinates,
    ipDetected,
    isUserDataLoaded,
    historyLocations.length,
  ]);

  const getHistoryArray = (res) => {
    return res.data.location_analysis.location_details.filter((item) => {
      if (
        item.location_type === "searched" ||
        item.status === "analyzed" ||
        (item.location_type === "Plant" && item.status === "analyzed") ||
        item.status === "requested"
      ) {
        if (item["analysis_data"]) {
          delete item["analysis_data"];
        }
        return true;
      }
      return false;
    });
  };

  const getPlantAray = (res) => {
    return res.data.location_analysis.location_details.filter((item) => {
      if (item.location_type === "Plant") {
        if (!item.unique_id) {
          item.unique_id = `${item.doc_id}_${item.rid}`;
        }
        if (item["analysis_data"]) {
          delete item["analysis_data"];
        }
        return true;
      }
      return false;
    });
  };

  const fetchLatestData = async (plotFirstHistory = false) => {
    // const _isFirstTime = isFirstTimeUser(userDetails.firstTimeUser);

    // setFirstTimeUser(_isFirstTime);

    // if (_isFirstTime) {
    //   try {
    //     let user_url = Urls.user_data;
    //     const payload = { firstTimeUser: false };
    //     await axios.post(user_url, payload);
    //     setFirstTimeUser(false);
    //   } catch (e) {
    //     console.log("Error while updating user visit status", e);
    //   }
    // }

    getUserData()
      .then(async (res) => {
        setAllowedLocations(res.data.location_analysis?.allowed_locations || 0);

        if (res.data.location_analysis) {
          setReferralCredits({
            referrals_credits:
              res.data.location_analysis.referrals_credits || 0,
            pending_referrals_count:
              res.data.location_analysis.pending_referrals_count || 0,
          });
        }
        if (
          res.data.location_analysis &&
          res.data.location_analysis.location_details &&
          res.data.location_analysis.location_details.length > 0
        )
          setPlantLocations(
            res.data.location_analysis.location_details.filter((item) => {
              item.unique_id = `${item.location}_${item.state}`;
              if (item.location_type === "Plant") {
                if (!item.unique_id) {
                  item.unique_id = `${item.location}_${item.state}`;
                }
                if (item["analysis_data"]) {
                  delete item["analysis_data"];
                }
                return true;
              }
              return false;
            }),
          );
        const historyData =
          res.data.location_analysis?.location_details?.filter((item) => {
            item.unique_id = `${item.location}_${item.state}`;
            const isValid =
              item.location_type === "searched" ||
              item.status === "analyzed" ||
              (item.location_type === "Plant" && item.status === "analyzed") ||
              item.status === "requested";
            if (isValid && item["analysis_data"]) delete item["analysis_data"];
            return isValid;
          }) || [];

        setHistoryLocations(historyData);
        setIsUserDataLoaded(true);
        const hasNoSearch =
          !analysisdata.searched_coordinates ||
          analysisdata.searched_coordinates.length === 0;

        setShow(false);

        if (plotFirstHistory) {
          let historylength = getHistoryArray(res).length;
          let plotData =
            historylength > 0
              ? getHistoryArray(res)[0]
              : getPlantAray(res).length > 0
                ? getPlantAray(res)[0]
                : {};

          if (plotData && historylength > 0) {
            if (location.state?.from_search) {
              getAnalysisData(location.state.data, "History");
            } else {
              getAnalysisData(plotData, "History");
            }
          }
        }
      })
      .catch((err) => {
        setIsUserDataLoaded(true);
        setShow(false);
      });
  };
  const getAnalysisData = (value, requestedFrom) => {
    if (!value || !value.location || !value.state) return;
    if (!requestedFrom) return;

    const uniqueId = `${value.location}_${value.state}`;
    const payload = {
      ...value,
      status: "requested",
      unique_id: uniqueId,
    };

    const requestBody = { location_details: [payload] };

    // 1. Log Activity
    Activity([
      {
        screen: "Location Dashboard",
        module: "Location Dashboard",
        user_activity: {
          ...requestBody,
          requested_using: requestedFrom,
        },
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);

    // 2. Track with Mixpanel
    const label = payload.label || "NA";
    mixpanel.track("User has searched for a location", {
      ApplicationName: Urls.mixpanelappname,
      ScreenName: "LoRRI-Locationdashboard",
      ModuleName: "landing_page",
      ActivityLog: "userSearchedLocationName",
      Data: `Searched: ${label}`,
      Definition: "User has searched for a location",
      ActivityType: "page_view",
      UserName: userDetails.user_name,
      UserEmail: userDetails.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : "",
    });

    // 3. Route Control
    const isNewSearch = requestedFrom === "Plant" || requestedFrom === "Search";
    const isInHistory = Array.isArray(historyLocations) &&
      historyLocations.some(
        (item) => item?.unique_id?.toLowerCase() === uniqueId.toLowerCase(),
      );
    const shouldRequestCredits = isNewSearch && !isInHistory && allowedLocations === 0;

    if (shouldRequestCredits) {
      document.getElementById("GetMoreCredits")?.click();
    } else {
      searchData(requestBody, payload, isNewSearch);
    }
  };

  const resetData = () => {
    setCurrentSearchedLocation("");
    setanalysisdata({});
  };
  const updateHistory = (locationToAdd, searchedHistory) => {
    // console.clear()
    var isLocationExist = false;
    // Also check if searched location is already exist in history
    for (let i = 0; i < searchedHistory.length; i++) {
      if (searchedHistory[i]["unique_id"] === locationToAdd["unique_id"]) {
        isLocationExist = true;
        break;
      }
    }
    // If location does not exist in the history then add the current location and update the history state
    if (!isLocationExist) {
      setHistoryLocations([locationToAdd, ...historyLocations] || []);
    }
  };

  const searchData = async (requestBody, location, shouldUpdate) => {
    setShow(true);

    try {
      const res = await axios.post(Urls.locationapi2, requestBody);
      const analysis = res?.data?.location_analysis;

      // Reset state before processing
      setanalysisdata({});
      setCurrentSearchedLocation("");

      if (!analysis) return;

      const allowed = analysis.allowed_locations;
      const detail = analysis.location_details?.[0];

      if (allowed) {
        setAllowedLocations(allowed);
      }

      if (detail) {
        const { location: loc, state, analysis_data: data } = detail;

        setCurrentSearchedLocation(Uppercase(`${loc}, ${state}`));

        if (data) {
          setanalysisdata(data);

          if (shouldUpdate) {
            updateHistory(location, historyLocations);
          }
        } else {
          document.getElementById("GetMoreCredits")?.click();
        }
      }
    } catch (err) {
      console.error("Location API error:", err);
    } finally {
      setShow(false);
    }
  };

  const steps = [
    {
      selector: '[data-tut="welcome"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            Welcome to Location Dashboard
          </div>
          <div style={{ color: "white", fontSize: "14px" }}>
            View transporters for your plant locations
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="plant-location"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            Your Plant Locations
          </div>
          <div style={{ color: "white", fontSize: "14px" }}>
            Click on the location to view the transporters
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="search-location"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            You can enter a location of your choice
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="view-tranporters"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            Click on the link to view Transporter Profile
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="history"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            View your previous searches
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="credits"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            Your Search Credits
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
    {
      selector: '[data-tut="get-credits"]',
      content: () => (
        <>
          <div style={{ color: "white", fontWeight: "unset" }}>
            Get more credits
          </div>
        </>
      ),
      style: {
        backgroundColor: "#1a73e8",
        borderRadius: "10px",
        border: "1px solid rgba(0, 103, 181, 1)",
        fontWeight: "unset",
        fontSize: "18px",
      },
    },
  ];

  const closeTour = () => {
    setisTourOpen(false);
  };

  // const openTour = () => {
  //     setisTourOpen(true)
  // };

  return (
    <Container className={classes["Container"]}>
      <Loader show={show} />
      {/* <PageBanner title="Location Dashboard" bannerClassName={classes['My-Banner']} /> */}
      <Row className={classes["space-around"]}>
        <h3 style={{ color: "white", fontSize: "20px", margin: 0 }}>Location Dashboard</h3>
      </Row>
      {isAllowed ? (
        <>
          {!isMobile() ? (
            <>
              <Row className={`${classes["flex100"]} ${classes["margin-top"]}`}>
                <Column id="Location-Dashboard-Sidebar">
                  {/* {firstTimeUser ? (
                    <Tour
                      steps={steps}
                      badgeContent={(curr, tot) => `${curr} of ${tot}`}
                      disableDotsNavigation="true"
                      lastStepNextButton={
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "white",
                            color: "black",
                          }}
                          className="btn btn-sm "
                        >
                          Done! Let's get started
                        </button>
                      }
                      nextButton={
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "white",
                            color: "black",
                          }}
                          className="btn btn-sm "
                        >
                          Next
                        </button>
                      }
                      prevButton={
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "white",
                            color: "black",
                          }}
                          className="btn btn-sm"
                        >
                          Previous
                        </button>
                      }
                      isOpen={isTourOpen}
                      showNavigation={false}
                      onRequestClose={closeTour}
                      className={classes["s-toast"]}
                    />
                  ) : null} */}

                  <Action
                    historyLocations={historyLocations}
                    plantLocations={plantLocations}
                    searchOptions={searchOptions}
                    setSearchOptions={setSearchOptions}
                    requestDataForLocation={getAnalysisData}
                    allowedLocations={allowedLocations}
                    currentSearchedLocation={currentSearchedLocation}
                    fetchLatestData={fetchLatestData}
                    toggleLoader={setShow}
                    referralCredits={referralCredits}
                  />
                </Column>
                <Column
                  id="LocationDashboardMapDiv"
                  className={`${classes["position-relative"]}`}
                >
                  <View
                    allowedLocations={allowedLocations}
                    currentSearchedLocation={currentSearchedLocation}
                    analysisdata={analysisdata}
                    offsetWidth={
                      document.getElementById("LocationDashboardMapDiv") &&
                        document.getElementById("LocationDashboardMapDiv")
                          .offsetWidth
                        ? document.getElementById("LocationDashboardMapDiv")
                          .offsetWidth
                        : 0
                    }
                    history={props.history}
                    resetData={resetData}
                    setcurrentLayer={setcurrentLayer}
                    currentLayer={currentLayer}
                    detectedCoords={detectedCoords}
                  />
                </Column>
              </Row>
            </>
          ) : (
            <>
              <Accordion>
                <Card>
                  <Accordion.Toggle
                    id="Location-Transporters-Dashboard1"
                    as={Card.Header}
                    eventKey="0"
                  >
                    <b>
                      <i className="fa fa-plus" /> Plant Location / District
                    </b>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <Column>
                        <Action
                          historyLocations={historyLocations}
                          plantLocations={plantLocations}
                          searchOptions={searchOptions}
                          setSearchOptions={setSearchOptions}
                          requestDataForLocation={getAnalysisData}
                          allowedLocations={allowedLocations}
                          currentSearchedLocation={currentSearchedLocation}
                          fetchLatestData={fetchLatestData}
                          toggleLoader={setShow}
                          referralCredits={referralCredits}
                        />
                      </Column>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    id="Location-Transporters-Dashboard"
                    as={Card.Header}
                    eventKey="1"
                  >
                    <b>
                      <i className="fa fa-plus" /> Transporters
                    </b>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <Dashboard
                        transporter_count={
                          analysisdata.transporters_count
                            ? analysisdata.transporters_count
                            : 0
                        }
                        currentSearchedLocation={currentSearchedLocation}
                        transporter_list={
                          analysisdata.transporter_list
                            ? analysisdata.transporter_list
                            : []
                        }
                        dashboard={
                          analysisdata.dashboard ? analysisdata.dashboard : []
                        }
                        setcurrentLayer={setcurrentLayer}
                        currentLayer={currentLayer}
                        inflowTransporterList={
                          analysisdata && analysisdata.inflow_transporter_list
                            ? analysisdata.inflow_transporter_list
                            : []
                        }
                        inflowDashboard={
                          analysisdata && analysisdata.inflow_dashboard
                            ? analysisdata.inflow_dashboard
                            : []
                        }
                        outflowTransporterList={
                          analysisdata && analysisdata.outflow_transporter_list
                            ? analysisdata.outflow_transporter_list
                            : []
                        }
                        outflowDashboard={
                          analysisdata && analysisdata.outflow_dashboard
                            ? analysisdata.outflow_dashboard
                            : []
                        }
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>

              <Map
                inflow={
                  analysisdata.network && analysisdata.network.inflow
                    ? analysisdata.network.inflow
                    : []
                }
                outflow={
                  analysisdata.network && analysisdata.network.outflow
                    ? analysisdata.network.outflow
                    : []
                }
                searched={
                  analysisdata.searched_coordinates
                    ? analysisdata.searched_coordinates
                    : []
                }
                analysisdata={analysisdata}
                transporter_list={
                  analysisdata.transporter_list
                    ? analysisdata.transporter_list
                    : []
                }
                dashboard={analysisdata.dashboard ? analysisdata.dashboard : []}
                offsetWidth={
                  document.getElementById("LocationDashboardMapDiv") &&
                    document.getElementById("LocationDashboardMapDiv").offsetWidth
                    ? document.getElementById("LocationDashboardMapDiv")
                      .offsetWidth
                    : 0
                }
                currentSearchedLocation={currentSearchedLocation}
                transporter_count={
                  analysisdata.transporters_count
                    ? analysisdata.transporters_count
                    : 0
                }
                history={props.history}
                detectedCoords={detectedCoords}
                resetData={resetData}
                setcurrentLayer={setcurrentLayer}
                currentLayer={currentLayer}
              />
            </>
          )}
        </>
      ) : null}
      {/* <Row className={classes["justify-content-center"]}>
        <button
          className={`btn btn-primary ${classes["Rate-Button"]}`}
          onClick={(e) => props.history.push("/myTransporters")}
        >
          <span className={classes["btn-text"]}>Rate My Transporters Now</span>{" "}
          <i className="fa fa-chevron-right" />
        </button>
      </Row> */}
    </Container>
  );
};
export default LocationDashboard;
